import React, { useState, useEffect, useMemo, useContext } from "react";
import { revjul } from "./util";
import { CTX } from "../components/Store";

/* -----------------------------------------------------------
   AccordionItem
------------------------------------------------------------ */
const AccordionItem = ({ title, evtdts, content }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen((o) => !o);

  return (
    <div className="accordion-item">
      <div className="accordion-title" onClick={toggle}>
        {title}
      </div>

      {isOpen && (
        <div className="accordion-content">
          {evtdts?.map((evt, i) => (
            <span className="evtdates" key={i}>
              {evt}
              <br />
            </span>
          ))}

          {content
            .split("~")
            .map((block, i) => (
              <p className="interp" key={i}>
                {block}
              </p>
            ))}
        </div>
      )}
    </div>
  );
};

/* -----------------------------------------------------------
   Title Mapper
------------------------------------------------------------ */
const TITLES = {
  na: "Natal Interpretations",
  tr: "Transit Predictions",
  p2: "Secondary Predictions",
  p3: "Tertiary Predictions",
  sa: "Solar Arc Predictions",
  tr100: "100 Days Predictions",
  lp: "Lunations Predictions",
  p3mer: "Tertiary Mercury",
  p3ven: "Tertiary Venus",
  p3mar: "Tertiary Mars",
};

/* -----------------------------------------------------------
   AccordionList
------------------------------------------------------------ */
const AccordionList = ({ items, itype, ifrom }) => {
  let title = TITLES[itype] || "";

  // synastry override
  if (itype === "tr" && ifrom.includes(",")) {
    title = "Synastry Interpretations";
  }

  return (
    <div className="accordion-list">
      <h1 style={{ textAlign: "center" }}>{title}</h1>

      {items.map((item, i) => (
        <AccordionItem
          key={i}
          title={item.title}
          evtdts={item.evts}
          content={item.interp}
        />
      ))}
    </div>
  );
};

/* -----------------------------------------------------------
   Interps (Main Component)
------------------------------------------------------------ */
export default function Interps() {
  const { st } = useContext(CTX);

  /* ---------------------------------------------------------
     Normalize and preprocess st.interps WITHOUT mutation
  ------------------------------------------------------------ */
  const normalizedItems = useMemo(() => {
    if (!st.interps) return [];

    return st.interps.map((it) => {
      const interp = it.interp.replaceAll("`", "'");
      let title = it.title;
      let days = it.days ?? "";
      let sep = " - ";

      const specialCase =
        title.startsWith("Moon Phase") ||
        title.startsWith("Progressed Sun") ||
        st.ptype === "na" ||
        st.ptype === "lp" ||
        st.from?.includes(",");

      if (specialCase) sep = "";

      if (title.startsWith("Moon Phase")) {
          title = `${title}`;
          sep = "";
          days = "";
      }
      // Progressed Sun: show date
      if (title.startsWith("Progressed Sun")) {
        title = `${title} ${revjul(it.jd)}`;
      } else {
        title = `${title}${sep}${days}`;
      }

      return {
        ...it,
        title,
        interp,
      };
    });
  }, [st.interps, st.ptype, st.from]);

  return (
    <AccordionList items={normalizedItems} itype={st.ptype} ifrom={st.from} />
  );
}
